import { Link } from "react-router-dom";

export default function Logo({ className = "", onClick }) {
  return (
    <Link
      to="/"
      onClick={onClick}
      data-testid="brand-logo"
      className={`group inline-flex items-baseline ${className}`}
      aria-label="Melbi"
    >
      <span className="font-display text-3xl md:text-[2.5rem] font-bold tracking-tight text-[#2C2B29] group-hover:text-[#C96A4E] transition-colors leading-none">
        Melbi
      </span>
      <span className="ml-0.5 text-3xl md:text-[2.5rem] font-bold leading-none text-[#C96A4E]">.</span>
    </Link>
  );
}
